module.exports = __webpack_public_path__ + "static/media/13.5d87a36e.JPG";